import { render } from "./ListeFicheInventairePage.vue?vue&type=template&id=0df61921&ts=true"
import script from "./ListeFicheInventairePage.vue?vue&type=script&lang=ts"
export * from "./ListeFicheInventairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__